import api from './api';

export const financeiroService = {
  getFaturas: async (params = {}) => {
    try {
      const response = await api.get('/financeiro/faturas', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching faturas:', error);
      throw error;
    }
  }
};

